<!--
 * @Author: van
 * @Date: 2021-07-29 14:08:10
 * @LastEditors: van
 * @LastEditTime: 2021-09-28 09:49:23
-->
<template>
  <div class="menuAuthBtn">
    <div v-if="menuAuth && menuAuth.length <= 3">
      <template v-for="item in menuAuth">
        <el-button :key="item.id"
                   type="primary"
                   :icon="item.icon"
                   size="mini"
                   @click="authFunc(item)">
          {{ item.name }}
        </el-button>
      </template>
    </div>
    <div v-else-if="menuAuth && menuAuth.length > 3">
      <template v-for="item in menuAuth.slice(0, 2)">
        <el-button type="primary"
                   :key="item.id"
                   :icon="item.icon"
                   size="mini"
                   @click="authFunc(item)">
          {{ item.name }}
        </el-button>
      </template>
      <el-dropdown @command="authFunc"
                   style="margin-left:10px">
        <el-button type="primary"
                   size="mini"
                   icon="el-icon-arrow-down">
          更多操作
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :key="item.id"
                            v-for="item in menuAuth.slice(2)"
                            :command="item">
            <i :class="item.icon"> </i>
            {{ item.name }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="selectList"
         v-if="selectList.length > 0">
      <icon class="el-icon-finished"></icon>&nbsp;已勾选：{{selectList.length}}条
    </div>
  </div>
</template>
<script>
export default {
    methods: {
        authFunc(item) {
            if (item.status_flag == 1) {
                this.$parent[item.funcName]();
            } else {
                this.$parent.batchChangeStatus(item);
            }
        },
    },
    props: {
        menuAuth: Array,
        selectList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>
<style lang="scss">
.menuAuthBtn {
    display: flex;
    margin-top: 1px;
    .selectList {
        line-height: 28px;
        height: 28px;
        color: $color-primary;
        box-sizing: border-box;
        padding: 0 12px;
        font-size: 12px;
    }
}
</style>